document.documentElement.classList.remove('no-js');
const openBtn=document.querySelector('[data-menu-open]');
const closeBtn=document.querySelector('[data-menu-close]');
const menu=document.querySelector('[data-menu]');
if(openBtn&&menu){openBtn.addEventListener('click',()=>menu.classList.add('is-open'));}
if(closeBtn&&menu){closeBtn.addEventListener('click',()=>menu.classList.remove('is-open'));}

document.querySelectorAll('.product-form').forEach(form=>{
  const select=form.querySelector('.variant-select');
  const radios=form.querySelectorAll('input[type="radio"]');
  if(!select||!radios.length) return;
  const update=()=>{
    const values=[...form.querySelectorAll('fieldset')].map(fs=>fs.querySelector('input:checked')?.value);
    const option=[...select.options].find(o=>values.every(v=>o.textContent.includes(v)));
    if(option){select.value=option.value;}
  };
  radios.forEach(r=>r.addEventListener('change',update));
});
